import React from 'react'
import ReactDOM from 'react-dom'
import App from './component/app/app'

ReactDOM.render(<App />, document.getElementById('root'))
